import { mediaItems } from '@/mocks/home';

const mediaImages = [
  'https://readdy.ai/api/search-image?query=Epic%20anime%20style%20scene%20with%20dramatic%20battle%20energy%20effects%2C%20warm%20glowing%20particles%2C%20fantasy%20cultivation%20theme%2C%20cinematic%20lighting%2C%20dynamic%20action%20composition%2C%20Chinese%20animation%20aesthetic%2C%20professional%20production%20quality%2C%20rich%20warm%20color%20palette%2C%20high%20quality%20digital%20art&width=800&height=500&seq=media-manga-01&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Colorful%20anime%20new%20season%20showcase%20collage%20with%20various%20character%20silhouettes%2C%20vibrant%20warm%20summer%20colors%2C%20Japanese%20animation%20style%2C%20festive%20atmosphere%2C%20clean%20organized%20layout%2C%20professional%20broadcast%20design%2C%20energetic%20composition%2C%20high%20quality&width=800&height=500&seq=media-manga-02&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Professional%20voice%20actor%20recording%20studio%20scene%20with%20microphone%20and%20manga%20storyboards%20on%20display%2C%20warm%20studio%20lighting%2C%20behind%20the%20scenes%20documentary%20style%2C%20creative%20atmosphere%2C%20Chinese%20animation%20production%2C%20intimate%20setting%2C%20professional%20quality&width=800&height=500&seq=media-manga-03&orientation=landscape',
];

export default function Media() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-screen-2xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 bg-secondary-100/70 text-secondary-700 text-xs font-medium px-3 py-1 rounded-full mb-4">
            <i className="ri-play-circle-line text-xs"></i>
            <span>精彩视频</span>
          </div>
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">
            漫迷视频
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            精彩动画PV、新番导览与独家专访，探索漫画之外的世界
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 max-w-6xl mx-auto">
          {mediaItems.map((item, i) => (
            <div
              key={item.title}
              className="group bg-background-50 border border-background-200/70 rounded-lg overflow-hidden hover:border-primary-200/60 transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-48 md:h-56 overflow-hidden">
                <img
                  src={mediaImages[i]}
                  alt={`古古漫画网 - ${item.title}`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/20 flex items-center justify-center">
                  <div className="w-14 h-14 flex items-center justify-center bg-background-50/90 rounded-full group-hover:scale-110 transition-transform">
                    <i className="ri-play-fill text-primary-500 text-2xl ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute top-3 left-3">
                  <span className="inline-block px-2.5 py-1 text-xs font-medium rounded bg-accent-500/90 text-background-50 whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute bottom-3 right-3">
                  <span className="inline-block px-2 py-0.5 text-xs font-medium rounded bg-black/60 text-background-50 whitespace-nowrap">
                    {item.duration}
                  </span>
                </div>
              </div>
              <div className="p-5 md:p-6">
                <h3 className="font-heading text-base text-foreground-900 mb-2">{item.title}</h3>
                <p className="text-foreground-500 text-sm leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}